import useAuth from 'hooks/use-auth'
import {
  attacksCompletedPagedGet,
  failureFlagsExperimentsCompletedGet,
  reliabilityTestsCompletedPagedGet,
  scenariosCompletedPagedGet
} from 'utils/endpoints-access'

export function useWhatRanAccess() {
  const {
    currentTeamId,
    hasEndpointAccess,
    hasFailureFlags,
    hasFaultInjection,
    hasReliabilityManagement
  } = useAuth()

  const accessOptions = { teamId: currentTeamId }

  const canShowAttacksSection =
    hasFaultInjection &&
    hasEndpointAccess(attacksCompletedPagedGet, accessOptions)
  const canShowFailureFlagsSection =
    hasFailureFlags &&
    hasEndpointAccess(failureFlagsExperimentsCompletedGet, accessOptions)
  const canShowScenariosSection =
    hasFaultInjection &&
    hasEndpointAccess(scenariosCompletedPagedGet, accessOptions)
  const canShowServiceSection =
    hasReliabilityManagement &&
    hasEndpointAccess(reliabilityTestsCompletedPagedGet, accessOptions)

  return {
    attacks: canShowAttacksSection,
    failureFlags: canShowFailureFlagsSection,
    scenarios: canShowScenariosSection,
    services: canShowServiceSection,
    section:
      canShowAttacksSection ||
      canShowFailureFlagsSection ||
      canShowServiceSection ||
      canShowScenariosSection
  }
}
